import common from '../common';

export default {
  jpath: ['spectra', 'xps'],
  find: common.basenameFind,
  getProperty: common.getTargetProperty,
};
